import React, { useContext, useEffect, useState } from 'react'
import _ from 'lodash'
import { Button, Row, Col } from 'reactstrap'
import LoadingOverlay from "react-loading-overlay"
import { useTranslation } from 'react-i18next'

import { UserContext } from "context/auth";

import Card from 'main_views/components/Card';
import Form from 'main_views/components/Form/form_v2'
import { updateForm, setFieldValue, getFieldsValues } from 'main_views/form/formHandler'
import { successToast, errorToast } from 'main_views/components/toast'
import { addDoc, updateDoc } from 'dbHandler'
import formFields from 'main_views/staff/fields'
import i18n from 'utils/translation/i18n'

function Settings(props) {

    let { t } = useTranslation()
    let { user: currentUser, updateUserInfo } = useContext(UserContext)

    let [form, setForm] = useState({})
    let [loading, setloading] = useState(false)

    useEffect(() => {

        let editInfoForm = getEditForm(currentUser)
        setForm(editInfoForm)

    }, [currentUser])

    let setChanges = (stateName, value, className) => {
        setFieldValue(form, stateName, value, className)
        setForm({ ...form })
    }

    let validation = async () => {

        let { isValid, data } = getFieldsValues(form)

        if (!isValid) return errorToast(t('please_complete_the_form'))

        // extract only the changed data
        let changedData = {}
        _.map(data, (field, key) => {
            if (field !== form[key].original_value)
                changedData[key] = field
        })

        if (_.isEmpty(changedData)) return errorToast('No Changes')

        // cheack if confirm pass is valid (if the pass was changed)
        if (changedData.password && !changedData.confirmPassword) return errorToast(t('please_confirm_the_password'))
        if (changedData.password !== changedData.confirmPassword) return errorToast(t('password_not_match'))

        await saveChanges(changedData)

    }

    let saveChanges = async (data) => {

        console.log({ data })

        data.uid = currentUser.uid
        data.staffDocId = currentUser.id

        let url = `https://us-central1-tickting-system.cloudfunctions.net/updateStaff`
        let options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            redirect: 'follow'
        }

        setloading(true)

        try {

            let response = await fetch(`${url}`, options)

            if (!response.ok)
                throw await Promise.reject(await response.json())

            if(data.email){
                updateUserInfo({ email: data.email })
            }
            successToast(t('your_data_was_updated_successfully'))

        } catch (error) {
            console.log({ error })
            errorToast(_.get(error, 'message', t('something_wrong')))

        } finally {
            setloading(false)
        }

    }

    return (
        <div className="content">

            <Card
                title='Settings'>
                <Form
                    inputs={form}
                    onChange={setChanges}
                />

                <Button
                    className="float-right" color="info"
                    onClick={validation}
                    disabled={loading}
                >
                    {t(loading ? 'loading' : 'save')}
                </Button>

            </Card>

        </div>

    )
}

export default Settings


/**
 *
 *
 * @param {object} staff
 * @returns {object}
 */
function getEditForm(staff) {

    let editForm = _.pick(_.cloneDeep(formFields), ['email', 'password', 'confirmPassword'])

    _.set(editForm, 'password.name', i18n.t('new_password'))

    // set the email & pass as not required fields
    _.set(editForm, 'email.required', false)
    _.set(editForm, 'password.required', false)
    _.set(editForm, 'confirmPassword.required', false)

    // set the permissons options
    let staffData = _.cloneDeep(staff)

    // update the fields values by the staff data
    let editInfoForm = updateForm(editForm, staffData)

    return editInfoForm
}